export enum UiMessageScope {
  GLOBAL = 'GLOBAL',
  LOCAL = 'LOCAL'
}
